<ng-container *ngIf="isVisible">
  <div class="timeline" cdkDrag cdkDragBoundary=".map-frame">
    <div class="timeline_handle">
      <mat-icon cdkDragHandle>drag_handler</mat-icon>
    </div>
    <div class="slider-grid">
      <mat-form-field appearance="outline">
        <mat-select [ngModel]="currentLayerId" (ngModelChange)="onLayerChange($event)">
          <mat-option *ngFor="let layer of layerMap | keyvalue" [value]="layer.value.id">
            {{ layer.value.label | uuid: ' ' | normalize }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-select [ngModel]="currentDateIndex" (ngModelChange)="onDateChange($event)">
          <mat-option *ngFor="let date of currentDates; let i = index" [value]="i">
            {{ date }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!--  -->
      <div class="d-flex align-items-center slider-container">
        <mat-slider
          min="0"
          [max]="currentDates.length - 1"
          step="1"
          [ngModel]="currentDateIndex"
          thumbLabel
          [displayWith]="getDate"
          (ngModelChange)="onDateChange($event)"
          color="primary"
          style="width: 100%"
        ></mat-slider>

      </div>
    </div>
    <div class="d-flex justify-content-center">
      <button mat-icon-button color="primary" class="timeline_play-btn" (click)="toggleAutoRun()">
        <div>
          <mat-icon *ngIf="!autoRun">play_arrow</mat-icon>
          <mat-icon *ngIf="autoRun">pause</mat-icon>
        </div>
      </button>
    </div>
  </div>
</ng-container>
